import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Constructionsolution() {
  return (
    <section className="construction_solution p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Choose a <span>Construction Software Solution</span> for Your
              Unique Business Needs
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="const-solution-box">
              <div className="num">01</div>
              <div className="content">
                <h5>Enterprise Resource Planning (ERP) for Construction</h5>
                <p>
                  Streamline resource management, financial planning, and
                  project tracking across multiple construction projects.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="const-solution-box">
              <div className="num">02</div>
              <div className="content">
                <h5>
                  Construction Project Management
                  <br className="d-none d-xl-block" /> Software
                </h5>
                <p>
                  Comprehensive management tools for planning, scheduling, and
                  budgeting throughout the project lifecycle.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="const-solution-box">
              <div className="num">03</div>
              <div className="content">
                <h5>
                  Supply Chain & Inventory Management
                  <br className="d-none d-xl-block" /> Software
                </h5>
                <p>
                  Automate time-intensive tasks like procurement and track
                  inventory to prevent shortages and reduce delays.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="const-solution-box">
              <div className="num">04</div>
              <div className="content">
                <h5>
                  Building Information Modeling (BIM)
                  <br className="d-none d-xl-block" /> Software
                </h5>
                <p>
                  Advanced Building information modeling (BIM) tools enhance
                  collaboration and accuracy in project design and execution.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="const-solution-box">
              <div className="num">05</div>
              <div className="content">
                <h5>
                  Construction Estimating
                  <br className="d-none d-xl-block" /> Software
                </h5>
                <p>
                  Simplify cost estimation to ensure accurate budgeting, improve
                  bid competitiveness, and win more construction projects.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="const-solution-box">
              <div className="num">06</div>
              <div className="content">
                <h5>
                  Bid Management
                  <br className="d-none d-xl-block" /> Software
                </h5>
                <p>
                  Simplify your preconstruction easily with reliable bid
                  management solutions. Automates and streamlines the bidding
                  process for efficient project acquisition.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4 mb-xl-0">
            <div className="const-solution-box">
              <div className="num">07</div>
              <div className="content">
                <h5>
                  Customer & Partner <br className="d-none d-xl-block" />{" "}
                  Portals
                </h5>
                <p>
                  Keep your project's stakeholders in the loop with secure and
                  centralized communication hubs for real-time updates and
                  seamless collaboration.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4 mb-xl-0">
            <div className="const-solution-box">
              <div className="num">08</div>
              <div className="content">
                <h5>
                  Equipment & Tools Management
                  <br className="d-none d-xl-block" /> Software
                </h5>
                <p>
                  Track and manage your heavy equipment, machinery, and usage to
                  optimize efficiency, reduce overheads, and minimize downtime.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="const-solution-box">
              <div className="num">09</div>
              <div className="content">
                <h5>
                  Construction Accounting
                  <br className="d-none d-xl-block" /> Software
                </h5>
                <p>
                  From costing to payrolls, simplify your financial management,
                  track project costs, and ensure compliance with industry
                  standards.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Constructionsolution;
